import {
  buildDefaultLocalMapTranslationKey,
  IBuildType,
  IShow,
  LocalMapType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import { ENV_KEY_PREFIX } from "tools/localization/envKeyPrefix";

export const localizeOrganiser = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "organiserLocalMap"> | undefined,
  t: UseTranslateResult["t"]
) => {
  const translationKey =
    buildType?.organiserLocalMap?.translationKey ||
    show?.localMap?.organiserLocalMap?.translationKey ||
    buildDefaultLocalMapTranslationKey(ENV_KEY_PREFIX, LocalMapType.Organiser);

  return t(translationKey, { count: 1 });
};
